import { useMemo } from 'react';
import type { UseTranslationOptions } from 'react-i18next';
import { useTranslation as ReactI18NextUseTranslation } from 'react-i18next';

type Options = UseTranslationOptions<undefined> & {
  [key: string]: unknown;
};

export default function useTranslation(
  ns: string | string[],
  options: Options = {}
) {
  const { t, ready } = ReactI18NextUseTranslation(ns, options);

  return useMemo(() => (ready ? t : t), [ready, t]);
}
